import API_SERVICE from "src/utils/axios";
import API_SERVICE_V1 from "src/utils/axiosv1";

const FILE_UPLOAD = "v4/jobOrders/bulk-upload-file";
const CREATE_PROJECT = "v4/shootnewLifestyleImage/create-project-web";
const CUSTOM_PRESET_LISTING = "v4/shootnewLifestyleImage/getCustomShootMarketPlace";
const PRESET_LISTING = 'v4/shootnewLifestyleImage/fetchPresetList';
const GOOGLE_DRIVE_ACCESS = "v4/jobOrders/drive-link-details?link=";
const GOOGLE_DRIVE_CREATE_JOB = "v4/shootnewLifestyleImage/createJobFromGoogleDrive";
const GOOGLE_DRIVE_PROJECT_NAME = "v4/jobOrders/drive-folder-name?link=";
const GOOGLE_DRIVE_INSTRUCTION = "v1/api/chat/sendMediaInChat";

export const getFileUploadPayload = (file, filePath) => {
  const formData = new FormData();
  filePath && formData.append("filePath", filePath);
  formData.append("dmsuploadBulk", file);
  return formData;
};
export const uploadFile = (file, options, filepath="") => {
  const payload = getFileUploadPayload(file, filepath);
  return API_SERVICE.post(FILE_UPLOAD, payload, options);
};

export const createProject = (payload, options) => {
  return API_SERVICE.post(CREATE_PROJECT, payload, options);
};

export const getFileS3Url = async (file) => {
  try {
    const response = await uploadFile(file);
    if (get(response, "data.success", false)) {
      const imageUrl = head(get(response, "data.images", []));
      return imageUrl;
    }
    return false;
  } catch (error) {}
};

export const getPresetListing = async() => {
  return await API_SERVICE.get(PRESET_LISTING);
}

export const validateAndGetGoogleDriveName = async(link) => {
  return await API_SERVICE.get(`${GOOGLE_DRIVE_PROJECT_NAME}${link}`);
};

export const validateGoogleDriveLink = async (link) => {
  return await API_SERVICE.get(`${GOOGLE_DRIVE_ACCESS}${link}`);
}

export const createGoogleDriveJob = async (payload) => {
  return await API_SERVICE.post(GOOGLE_DRIVE_CREATE_JOB,payload);
}

export const sendGoogleDriveInstruction = async (formData) => {
  return await API_SERVICE_V1.post(GOOGLE_DRIVE_INSTRUCTION,formData);
}